// PSI Audit Descriptions extracted from Lighthouse
// Generated from PSI response

export const PSI_AUDIT_DESCRIPTIONS = {
  "html-lang-valid": {
    title: "`<html>` element has a valid value for its `[lang]` attribute",
    description:
      "Specifying a valid [BCP 47 language](https://www.w3.org/International/questions/qa-choosing-language-tags#question) helps screen readers announce text properly.",
    link: "https://www.w3.org/International/questions/qa-choosing-language-tags#question",
  },
  "duplicated-javascript": {
    title: "Remove duplicate modules in JavaScript bundles",
    description:
      "Remove large, duplicate JavaScript modules from bundles to reduce unnecessary bytes consumed by network activity. ",
    link: undefined,
  },
  "first-meaningful-paint": {
    title: "First Meaningful Paint",
    description:
      "First Meaningful Paint measures when the primary content of a page is visible.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/first-meaningful-paint/",
  },
  "modern-image-formats": {
    title: "Serve images in next-gen formats",
    description:
      "Image formats like WebP and AVIF often provide better compression than PNG or JPEG, which means faster downloads and less data consumption.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/uses-webp-images/",
  },
  "unsized-images": {
    title: "Image elements have explicit `width` and `height`",
    description:
      "Set an explicit width and height on image elements to reduce layout shifts and improve CLS.",
    link: "https://web.dev/articles/optimize-cls#images_without_dimensions",
  },
  "interactive-element-affordance": {
    title: "Interactive elements indicate their purpose and state",
    description:
      "Interactive elements, such as links and buttons, should indicate their state and be distinguishable from non-interactive elements.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/interactive-element-affordance/",
  },
  "aria-tooltip-name": {
    title: "ARIA `tooltip` elements have accessible names",
    description:
      "When a tooltip element doesn't have an accessible name, screen readers announce it with a generic name, making it unusable for users who rely on screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-tooltip-name",
  },
  "aria-required-children": {
    title:
      "Elements with an ARIA `[role]` that require children to contain a specific `[role]` have all required children.",
    description:
      "Some ARIA parent roles must contain specific child roles to perform their intended accessibility functions.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-required-children",
  },
  "inp-breakdown-insight": {
    title: "INP breakdown",
    description:
      "Start investigating with the longest subpart. [Delays can be minimized](https://web.dev/articles/optimize-inp#optimize_interactions). To reduce processing duration, [optimize the main-thread costs](https://web.dev/articles/optimize-long-tasks), often JS.",
    link: "https://web.dev/articles/optimize-inp#optimize_interactions",
  },
  "html-xml-lang-mismatch": {
    title:
      "`<html>` element has an `[xml:lang]` attribute with the same base language as the `[lang]` attribute.",
    description:
      "If the webpage does not specify a consistent language, then the screen reader might not announce the page's text correctly.",
    link: "https://dequeuniversity.com/rules/axe/4.10/html-xml-lang-mismatch",
  },
  "aria-meter-name": {
    title: "ARIA `meter` elements have accessible names",
    description:
      "When a meter element doesn't have an accessible name, screen readers announce it with a generic name, making it unusable for users who rely on screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-meter-name",
  },
  "custom-controls-roles": {
    title: "Custom controls have ARIA roles",
    description: "Custom interactive controls have appropriate ARIA roles.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/custom-control-roles/",
  },
  "trusted-types-xss": {
    title: "Mitigate DOM-based XSS with Trusted Types",
    description:
      "The `require-trusted-types-for` directive in the `Content-Security-Policy` (CSP) header instructs user agents to control the data passed to DOM XSS sink functions.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/trusted-types-xss",
  },
  "mainthread-work-breakdown": {
    title: "Minimizes main-thread work",
    description:
      "Consider reducing the time spent parsing, compiling and executing JS. You may find delivering smaller JS payloads helps with this.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/mainthread-work-breakdown/",
  },
  "aria-allowed-attr": {
    title: "`[aria-*]` attributes match their roles",
    description:
      "Each ARIA `role` supports a specific subset of `aria-*` attributes. Mismatching these invalidates the `aria-*` attributes.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-allowed-attr",
  },
  "cls-culprits-insight": {
    title: "Layout shift culprits",
    description:
      "Layout shifts occur when elements move absent any user interaction. [Investigate the causes of layout shifts](https://web.dev/articles/optimize-cls), such as elements being added, removed, or their fonts changing as the page loads.",
    link: "https://web.dev/articles/optimize-cls",
  },
  "resource-summary": {
    title: "Resources Summary",
    description: "Aggregates all network requests and groups them by type",
    link: undefined,
  },
  "unminified-css": {
    title: "Minify CSS",
    description: "Minifying CSS files can reduce network payload sizes.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/unminified-css/",
  },
  "unused-css-rules": {
    title: "Reduce unused CSS",
    description:
      "Reduce unused rules from stylesheets and defer CSS not used for above-the-fold content to decrease bytes consumed by network activity.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/unused-css-rules/",
  },
  "aria-progressbar-name": {
    title: "ARIA `progressbar` elements have accessible names",
    description:
      "When a `progressbar` element doesn't have an accessible name, screen readers announce it with a generic name, making it unusable for users who rely on screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-progressbar-name",
  },
  "aria-prohibited-attr": {
    title: "Elements use only permitted ARIA attributes",
    description:
      "Using ARIA attributes in roles where they are prohibited can mean that important information is not communicated to users of assistive technologies.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-prohibited-attr",
  },
  interactive: {
    title: "Time to Interactive",
    description:
      "Time to Interactive is the amount of time it takes for the page to become fully interactive.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/interactive/",
  },
  "dom-size": {
    title: "Avoid an excessive DOM size",
    description:
      "A large DOM will increase memory usage, cause longer [style calculations](https://developers.google.com/web/fundamentals/performance/rendering/reduce-the-scope-and-complexity-of-style-calculations), and produce costly [layout reflows](https://developers.google.com/speed/articles/reflow).",
    link: "https://developers.google.com/web/fundamentals/performance/rendering/reduce-the-scope-and-complexity-of-style-calculations",
  },
  "aria-text": {
    title:
      "Elements with the `role=text` attribute do not have focusable descendents.",
    description:
      "Adding `role=text` around a text node split by markup enables VoiceOver to treat it as one phrase, but the element's focusable descendents will not be announced.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-text",
  },
  viewport: {
    title: 'Has a `<meta name="viewport">` tag with `width` or `initial-scale`',
    description:
      'A `<meta name="viewport">` not only optimizes your app for mobile screen sizes, but also prevents [a 300 millisecond delay to user input](https://developer.chrome.com/blog/300ms-tap-delay-gone-away/).',
    link: "https://developer.chrome.com/blog/300ms-tap-delay-gone-away/",
  },
  "custom-controls-labels": {
    title: "Custom controls have associated labels",
    description:
      "Custom interactive controls have associated labels, provided by aria-label or aria-labelledby.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/custom-controls-labels/",
  },
  "offscreen-images": {
    title: "Defer offscreen images",
    description:
      "Consider lazy-loading offscreen and hidden images after all critical resources have finished loading to lower time to interactive.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/offscreen-images/",
  },
  "image-size-responsive": {
    title: "Serves images with appropriate resolution",
    description:
      "Image natural dimensions should be proportional to the display size and the pixel ratio to maximize image clarity.",
    link: "https://web.dev/articles/serve-responsive-images",
  },
  "aria-roles": {
    title: "`[role]` values are valid",
    description:
      "ARIA roles must have valid values in order to perform their intended accessibility functions.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-roles",
  },
  "http-status-code": {
    title: "Page has successful HTTP status code",
    description:
      "Pages with unsuccessful HTTP status codes may not be indexed properly.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/http-status-code/",
  },
  "clickjacking-mitigation": {
    title: "Mitigate clickjacking with XFO or CSP",
    description:
      "The `X-Frame-Options` (XFO) header or the `frame-ancestors` directive in the `Content-Security-Policy` (CSP) header control where a page can be embedded. These can mitigate clickjacking attacks by blocking some or all sites from embedding the page.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/clickjacking-mitigation",
  },
  "document-latency-insight": {
    title: "Document request latency",
    description:
      "Your first network request is the most important.  Reduce its latency by avoiding redirects, ensuring a fast server response, and enabling text compression.",
    link: undefined,
  },
  "uses-rel-preconnect": {
    title: "Preconnect to required origins",
    description:
      "Consider adding `preconnect` or `dns-prefetch` resource hints to establish early connections to important third-party origins.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/uses-rel-preconnect/",
  },
  "uses-responsive-images": {
    title: "Properly size images",
    description:
      "Serve images that are appropriately-sized to save cellular data and improve load time.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/uses-responsive-images/",
  },
  "legacy-javascript": {
    title: "Avoid serving legacy JavaScript to modern browsers",
    description:
      "Polyfills and transforms enable legacy browsers to use new JavaScript features. However, many aren't necessary for modern browsers. Consider modifying your JavaScript build process to not transpile [Baseline](https://web.dev/baseline) features, unless you know you must support legacy browsers.",
    link: "https://web.dev/baseline",
  },
  "notification-on-start": {
    title: "Avoids requesting the notification permission on page load",
    description:
      "Users are mistrustful of or confused by sites that request to send notifications without context. Consider tying the request to user gestures instead.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/notification-on-start/",
  },
  "third-party-summary": {
    title: "Minimize third-party usage",
    description:
      "Third-party code can significantly impact load performance. Limit the number of redundant third-party providers and try to load third-party code after your page has primarily finished loading.",
    link: "https://developers.google.com/web/fundamentals/performance/optimizing-content-efficiency/loading-third-party-javascript/",
  },
  "uses-passive-event-listeners": {
    title: "Uses passive listeners to improve scrolling performance",
    description:
      "Consider marking your touch and wheel event listeners as `passive` to improve your page's scroll performance.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/uses-passive-event-listeners/",
  },
  "cumulative-layout-shift": {
    title: "Cumulative Layout Shift",
    description:
      "Cumulative Layout Shift measures the movement of visible elements within the viewport.",
    link: "https://web.dev/articles/cls",
  },
  "managed-focus": {
    title: "The user's focus is directed to new content added to the page",
    description:
      "If new content, such as a dialog, is added to the page, the user's focus is directed to it.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/managed-focus/",
  },
  "largest-contentful-paint": {
    title: "Largest Contentful Paint",
    description:
      "Largest Contentful Paint marks the time at which the largest text or image is painted.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/lighthouse-largest-contentful-paint/",
  },
  "aria-valid-attr-value": {
    title: "`[aria-*]` attributes have valid values",
    description:
      "Assistive technologies, like screen readers, can't interpret ARIA attributes with invalid values.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-valid-attr-value",
  },
  "input-button-name": {
    title: "Input buttons have discernible text.",
    description:
      "Adding discernable and accessible text to input buttons may help screen reader users understand the purpose of the input button.",
    link: "https://dequeuniversity.com/rules/axe/4.10/input-button-name",
  },
  "third-parties-insight": {
    title: "3rd parties",
    description:
      "3rd party code can significantly impact load performance. [Reduce and defer loading of 3rd party code](https://web.dev/articles/optimizing-content-efficiency-loading-third-party-javascript/) to prioritize your page's content.",
    link: "https://web.dev/articles/optimizing-content-efficiency-loading-third-party-javascript/",
  },
  charset: {
    title: "Properly defines charset",
    description:
      "A character encoding declaration is required. It can be done with a `<meta>` tag in the first 1024 bytes of the HTML or in the Content-Type HTTP response header.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/charset/",
  },
  "network-server-latency": {
    title: "Server Backend Latencies",
    description:
      "Server latencies can impact web performance. If the server latency of an origin is high, it's an indication the server is overloaded or has poor backend performance.",
    link: "https://hpbn.co/primer-on-web-performance/#analyzing-the-resource-waterfall",
  },
  "video-caption": {
    title:
      '`<video>` elements contain a `<track>` element with `[kind="captions"]`',
    description:
      "When a video provides a caption it is easier for deaf and hearing impaired users to access its information.",
    link: "https://dequeuniversity.com/rules/axe/4.10/video-caption",
  },
  "aria-treeitem-name": {
    title: "ARIA `treeitem` elements have accessible names",
    description:
      "When a `treeitem` element doesn't have an accessible name, screen readers announce it with a generic name, making it unusable for users who rely on screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-treeitem-name",
  },
  list: {
    title:
      "Lists contain only `<li>` elements and script supporting elements (`<script>` and `<template>`).",
    description:
      "Screen readers have a specific way of announcing lists. Ensuring proper list structure aids screen reader output.",
    link: "https://dequeuniversity.com/rules/axe/4.10/list",
  },
  "font-display": {
    title: "Ensure text remains visible during webfont load",
    description:
      "Leverage the `font-display` CSS feature to ensure text is user-visible while webfonts are loading.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/font-display/",
  },
  "uses-text-compression": {
    title: "Enable text compression",
    description:
      "Text-based resources should be served with compression (gzip, deflate or brotli) to minimize total network bytes.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/uses-text-compression/",
  },
  "speed-index": {
    title: "Speed Index",
    description:
      "Speed Index shows how quickly the contents of a page are visibly populated.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/speed-index/",
  },
  "image-aspect-ratio": {
    title: "Displays images with correct aspect ratio",
    description: "Image display dimensions should match natural aspect ratio.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/image-aspect-ratio/",
  },
  "final-screenshot": {
    title: "Final Screenshot",
    description: "The last screenshot captured of the pageload.",
    link: undefined,
  },
  "crawlable-anchors": {
    title: "Links are crawlable",
    description:
      "Search engines may use `href` attributes on links to crawl websites. Ensure that the `href` attribute of anchor elements links to an appropriate destination, so more pages of the site can be discovered.",
    link: "https://support.google.com/webmasters/answer/9112205",
  },
  "aria-command-name": {
    title: "`button`, `link`, and `menuitem` elements have accessible names",
    description:
      "When an element doesn't have an accessible name, screen readers announce it with a generic name, making it unusable for users who rely on screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-command-name",
  },
  metrics: {
    title: "Metrics",
    description: "Collects all available metrics.",
    link: undefined,
  },
  redirects: {
    title: "Avoid multiple page redirects",
    description:
      "Redirects introduce additional delays before the page can be loaded.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/redirects/",
  },
  "select-name": {
    title: "Select elements have associated label elements.",
    description:
      "Form elements without effective labels can create frustrating experiences for screen reader users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/select-name",
  },
  "origin-isolation": {
    title: "Ensure proper origin isolation with COOP",
    description:
      "The Cross-Origin-Opener-Policy (COOP) can be used to isolate the top-level window from other documents such as pop-ups.",
    link: "https://web.dev/articles/why-coop-coep#coop",
  },
  "table-fake-caption": {
    title:
      "Tables use `<caption>` instead of cells with the `[colspan]` attribute to indicate a caption.",
    description:
      "Screen readers have features to make navigating tables easier. Ensuring that tables use the actual caption element instead of cells with the `[colspan]` attribute may improve the experience for screen reader users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/table-fake-caption",
  },
  diagnostics: {
    title: "Diagnostics",
    description: "Collection of useful page vitals.",
    link: undefined,
  },
  "no-document-write": {
    title: "Avoids `document.write()`",
    description:
      "For users on slow connections, external scripts dynamically injected via `document.write()` can delay page load by tens of seconds.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/no-document-write/",
  },
  "render-blocking-resources": {
    title: "Eliminate render-blocking resources",
    description:
      "Resources are blocking the first paint of your page. Consider delivering critical JS/CSS inline and deferring all non-critical JS/styles.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/render-blocking-resources/",
  },
  "long-tasks": {
    title: "Avoid long main-thread tasks",
    description:
      "Lists the longest tasks on the main thread, useful for identifying worst contributors to input delay.",
    link: "https://web.dev/articles/optimize-long-tasks",
  },
  "aria-input-field-name": {
    title: "ARIA input fields have accessible names",
    description:
      "When an input field doesn't have an accessible name, screen readers announce it with a generic name, making it unusable for users who rely on screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-input-field-name",
  },
  "aria-allowed-role": {
    title: "Uses ARIA roles only on compatible elements",
    description:
      "Many HTML elements can only be assigned certain ARIA roles. Using ARIA roles where they are not allowed can interfere with the accessibility of the web page.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-allowed-role",
  },
  "valid-lang": {
    title: "`[lang]` attributes have a valid value",
    description:
      "Specifying a valid [BCP 47 language](https://www.w3.org/International/questions/qa-choosing-language-tags#question) on elements helps ensure that text is pronounced correctly by a screen reader.",
    link: "https://www.w3.org/International/questions/qa-choosing-language-tags#question",
  },
  "color-contrast": {
    title: "Background and foreground colors have a sufficient contrast ratio",
    description:
      "Low-contrast text is difficult or impossible for many users to read.",
    link: "https://dequeuniversity.com/rules/axe/4.10/color-contrast",
  },
  "link-name": {
    title: "Links have a discernible name",
    description:
      "Link text (and alternate text for images, when used as links) that is discernible, unique, and focusable improves the navigation experience for screen reader users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/link-name",
  },
  "td-has-header": {
    title:
      "`<td>` elements in a large `<table>` have one or more table headers.",
    description:
      "Screen readers have features to make navigating tables easier. Ensuring that `<td>` elements in a large table (3 or more cells in width and height) have an associated table header may improve the experience for screen reader users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/td-has-header",
  },
  "aria-dialog-name": {
    title:
      'Elements with `role="dialog"` or `role="alertdialog"` have accessible names.',
    description:
      "ARIA dialog elements without accessible names may prevent screen readers users from discerning the purpose of these elements.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-dialog-name",
  },
  "uses-long-cache-ttl": {
    title: "Serve static assets with an efficient cache policy",
    description:
      "A long cache lifetime can speed up repeat visits to your page.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/uses-long-cache-ttl/",
  },
  "uses-optimized-images": {
    title: "Efficiently encode images",
    description: "Optimized images load faster and consume less cellular data.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/uses-optimized-images/",
  },
  doctype: {
    title: "Page has the HTML doctype",
    description:
      "Specifying a doctype prevents the browser from switching to quirks-mode.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/doctype/",
  },
  "network-dependency-tree-insight": {
    title: "Network dependency tree",
    description:
      "[Avoid chaining critical requests](https://developer.chrome.com/docs/lighthouse/performance/critical-request-chains) by reducing the length of chains, reducing the download size of resources, or deferring the download of unnecessary resources to improve page load.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/critical-request-chains",
  },
  "max-potential-fid": {
    title: "Max Potential First Input Delay",
    description:
      "The maximum potential First Input Delay that your users could experience is the duration of the longest task.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/lighthouse-max-potential-fid/",
  },
  listitem: {
    title:
      "List items (`<li>`) are contained within `<ul>`, `<ol>` or `<menu>` parent elements",
    description:
      "Screen readers require list items (`<li>`) to be contained within a parent `<ul>`, `<ol>` or `<menu>` to be announced properly.",
    link: "https://dequeuniversity.com/rules/axe/4.10/listitem",
  },
  "image-redundant-alt": {
    title:
      "Image elements do not have `[alt]` attributes that are redundant text.",
    description:
      "Informative elements should aim for short, descriptive alternative text. Alternative text that is exactly the same as the text adjacent to the link or image is potentially confusing for screen reader users, because the text will be read twice.",
    link: "https://dequeuniversity.com/rules/axe/4.10/image-redundant-alt",
  },
  "image-delivery-insight": {
    title: "Improve image delivery",
    description:
      "Reducing the download time of images can improve the perceived load time of the page and LCP.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/uses-optimized-images/",
  },
  "object-alt": {
    title: "`<object>` elements have alternate text",
    description:
      "Screen readers cannot translate non-text content. Adding alternate text to `<object>` elements helps screen readers convey meaning to users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/object-alt",
  },
  "lcp-lazy-loaded": {
    title: "Largest Contentful Paint image was not lazily loaded",
    description:
      "Above-the-fold images that are lazily loaded render later in the page lifecycle, which can delay the largest contentful paint.",
    link: "https://web.dev/articles/lcp-lazy-loading",
  },
  "form-field-multiple-labels": {
    title: "No form fields have multiple labels",
    description:
      "Form fields with multiple labels can be confusingly announced by assistive technologies like screen readers which use either the first, the last, or all of the labels.",
    link: "https://dequeuniversity.com/rules/axe/4.10/form-field-multiple-labels",
  },
  "aria-valid-attr": {
    title: "`[aria-*]` attributes are valid and not misspelled",
    description:
      "Assistive technologies, like screen readers, can't interpret ARIA attributes with invalid names.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-valid-attr",
  },
  "third-party-facades": {
    title: "Lazy load third-party resources with facades",
    description:
      "Some third-party embeds can be lazy loaded. Consider replacing them with a facade until they are required.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/third-party-facades/",
  },
  "empty-heading": {
    title: "All heading elements contain content.",
    description:
      "A heading with no content or inaccessible text prevent screen reader users from accessing information on the page's structure.",
    link: "https://dequeuniversity.com/rules/axe/4.10/empty-heading",
  },
  "label-content-name-mismatch": {
    title: "Elements with visible text labels have matching accessible names.",
    description:
      "Visible text labels that do not match the accessible name can result in a confusing experience for screen reader users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/label-content-name-mismatch",
  },
  "network-requests": {
    title: "Network Requests",
    description: "Lists the network requests that were made during page load.",
    link: undefined,
  },
  "focusable-controls": {
    title: "Interactive controls are keyboard focusable",
    description:
      "Custom interactive controls are keyboard focusable and display a focus indicator.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/focusable-controls/",
  },
  "is-on-https": {
    title: "Uses HTTPS",
    description:
      "All sites should be protected with HTTPS, even ones that don't handle sensitive data. This includes avoiding mixed content, where some resources are loaded over HTTP despite the initial request being served over HTTPS. HTTPS prevents intruders from tampering with or passively listening in on the communications between your app and your users, and is a prerequisite for HTTP/2 and many new web platform APIs.",
    link: "https://developers.google.com/web/fundamentals/security/prevent-mixed-content/what-is-mixed-content",
  },
  "layout-shifts": {
    title: "Avoid large layout shifts",
    description:
      "These are the largest layout shifts observed on the page. Each table item represents a single layout shift, and shows the element that shifted the most. Below each item are possible root causes that led to the layout shift. Some of these layout shifts may not be included in the CLS metric value due to [windowing](https://web.dev/articles/cls#what_is_cls).",
    link: "https://web.dev/articles/cls#what_is_cls",
  },
  "landmark-one-main": {
    title: "Document has a main landmark.",
    description:
      "One main landmark helps screen reader users navigate a web page.",
    link: "https://dequeuniversity.com/rules/axe/4.10/landmark-one-main",
  },
  "definition-list": {
    title:
      "`<dl>`'s contain only properly-ordered `<dt>` and `<dd>` groups, `<script>`, `<template>` or `<div>` elements.",
    description:
      "When definition lists are not properly marked up, screen readers may produce confusing or inaccurate output.",
    link: "https://dequeuniversity.com/rules/axe/4.10/definition-list",
  },
  "valid-source-maps": {
    title: "Page has valid source maps",
    description:
      "Source maps translate minified code to the original source code. This helps developers debug in production. In addition, Lighthouse is able to provide further insights. Consider deploying source maps to take advantage of these benefits.",
    link: "https://developer.chrome.com/docs/devtools/javascript/source-maps/",
  },
  "prioritize-lcp-image": {
    title: "Preload Largest Contentful Paint image",
    description:
      "If the LCP element is dynamically added to the page, you should preload the image in order to improve LCP.",
    link: "https://web.dev/articles/optimize-lcp#optimize_when_the_resource_is_discovered",
  },
  "duplicated-javascript-insight": {
    title: "Duplicated JavaScript",
    description:
      "Remove large, duplicate JavaScript modules from bundles to reduce unnecessary bytes consumed by network activity.",
    link: undefined,
  },
  dlitem: {
    title: "Definition list items are wrapped in `<dl>` elements",
    description:
      "Definition list items (`<dt>` and `<dd>`) must be wrapped in a parent `<dl>` element to ensure that screen readers can properly announce them.",
    link: "https://dequeuniversity.com/rules/axe/4.10/dlitem",
  },
  "total-blocking-time": {
    title: "Total Blocking Time",
    description:
      "Sum of all time periods between FCP and Time to Interactive, when task length exceeded 50ms, expressed in milliseconds.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/lighthouse-total-blocking-time/",
  },
  "non-composited-animations": {
    title: "Avoid non-composited animations",
    description:
      "Animations which are not composited can be janky and increase CLS.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/non-composited-animations/",
  },
  "largest-contentful-paint-element": {
    title: "Largest Contentful Paint element",
    description:
      "This is the largest contentful element painted within the viewport.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/lighthouse-largest-contentful-paint/",
  },
  "aria-hidden-body": {
    title: '`[aria-hidden="true"]` is not present on the document `<body>`',
    description:
      'Assistive technologies, like screen readers, work inconsistently when `aria-hidden="true"` is set on the document `<body>`.',
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-hidden-body",
  },
  "table-duplicate-name": {
    title:
      "Tables have different content in the summary attribute and `<caption>`.",
    description:
      "The summary attribute should describe the table structure, while `<caption>` should have the onscreen title. Accurate table mark-up helps users of screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/table-duplicate-name",
  },
  "use-landmarks": {
    title: "HTML5 landmark elements are used to improve navigation",
    description:
      "Landmark elements (`<main>`, `<nav>`, etc.) are used to improve the keyboard navigation of the page for assistive technology.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/use-landmarks/",
  },
  "link-text": {
    title: "Links have descriptive text",
    description:
      "Descriptive link text helps search engines understand your content.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/link-text/",
  },
  "paste-preventing-inputs": {
    title: "Allows users to paste into input fields",
    description:
      "Preventing input pasting is a bad practice for the UX, and weakens security by blocking password managers.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/paste-preventing-inputs/",
  },
  "critical-request-chains": {
    title: "Avoid chaining critical requests",
    description:
      "The Critical Request Chains below show you what resources are loaded with a high priority. Consider reducing the length of chains, reducing the download size of resources, or deferring the download of unnecessary resources to improve page load.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/critical-request-chains/",
  },
  "aria-toggle-field-name": {
    title: "ARIA toggle fields have accessible names",
    description:
      "When a toggle field doesn't have an accessible name, screen readers announce it with a generic name, making it unusable for users who rely on screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-toggle-field-name",
  },
  "aria-conditional-attr": {
    title: "ARIA attributes are used as specified for the element's role",
    description:
      "Some ARIA attributes are only allowed on an element under certain conditions.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-conditional-attr",
  },
  "offscreen-content-hidden": {
    title: "Offscreen content is hidden from assistive technology",
    description:
      "Offscreen content is hidden with display: none or aria-hidden=true.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/offscreen-content-hidden/",
  },
  "document-title": {
    title: "Document has a `<title>` element",
    description:
      "The title gives screen reader users an overview of the page, and search engine users rely on it heavily to determine if a page is relevant to their search.",
    link: "https://dequeuniversity.com/rules/axe/4.10/document-title",
  },
  "csp-xss": {
    title: "Ensure CSP is effective against XSS attacks",
    description:
      "A strong Content Security Policy (CSP) significantly reduces the risk of cross-site scripting (XSS) attacks.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/csp-xss/",
  },
  "bootup-time": {
    title: "JavaScript execution time",
    description:
      "Consider reducing the time spent parsing, compiling, and executing JS. You may find delivering smaller JS payloads helps with this.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/bootup-time/",
  },
  "is-crawlable": {
    title: "Page isn’t blocked from indexing",
    description:
      "Search engines are unable to include your pages in search results if they don't have permission to crawl them.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/is-crawlable/",
  },
  "image-alt": {
    title: "Image elements have `[alt]` attributes",
    description:
      "Informative elements should aim for short, descriptive alternate text. Decorative elements can be ignored with an empty alt attribute.",
    link: "https://dequeuniversity.com/rules/axe/4.10/image-alt",
  },
  "geolocation-on-start": {
    title: "Avoids requesting the geolocation permission on page load",
    description:
      "Users are mistrustful of or confused by sites that request their location without context. Consider tying the request to a user action instead.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/geolocation-on-start/",
  },
  "cache-insight": {
    title: "Use efficient cache lifetimes",
    description:
      "A long cache lifetime can speed up repeat visits to your page.",
    link: "https://web.dev/uses-long-cache-ttl/",
  },
  "font-size": {
    title: "Document uses legible font sizes",
    description:
      "Font sizes less than 12px are too small to be legible and require mobile visitors to “pinch to zoom” in order to read. Strive to have >60% of page text ≥12px.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/font-size/",
  },
  "network-rtt": {
    title: "Network Round Trip Times",
    description:
      "Network round trip times (RTT) have a large impact on performance. If the RTT to an origin is high, it's an indication that servers closer to the user could improve performance.",
    link: "https://hpbn.co/primer-on-latency-and-bandwidth/",
  },
  "third-party-cookies": {
    title: "Avoids third-party cookies",
    description: "Third-party cookies may be blocked in some contexts.",
    link: "https://privacysandbox.google.com/cookies/prepare/overview",
  },
  "lcp-breakdown-insight": {
    title: "LCP breakdown",
    description:
      "Each [subpart has specific improvement strategies](https://web.dev/articles/optimize-lcp#lcp-breakdown). Ideally, most of the LCP time should be spent on loading the resources, not within delays.",
    link: "https://web.dev/articles/optimize-lcp#lcp-breakdown",
  },
  "robots-txt": {
    title: "robots.txt is valid",
    description:
      "If your robots.txt file is malformed, crawlers may not be able to understand how you want your website to be crawled or indexed.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/invalid-robots-txt/",
  },
  "aria-hidden-focus": {
    title:
      '`[aria-hidden="true"]` elements do not contain focusable descendents',
    description:
      'Focusable descendents within an `[aria-hidden="true"]` element prevent those interactive elements from being available to users of assistive technologies like screen readers.',
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-hidden-focus",
  },
  "aria-required-attr": {
    title: "`[role]`s have all required `[aria-*]` attributes",
    description:
      "Some ARIA roles have required attributes that describe the state of the element to screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-required-attr",
  },
  "visual-order-follows-dom": {
    title: "Visual order on the page follows DOM order",
    description:
      "DOM order matches the visual order, improving navigation for assistive technology.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/visual-order-follows-dom/",
  },
  "meta-refresh": {
    title: 'The document does not use `<meta http-equiv="refresh">`',
    description:
      "Users do not expect a page to refresh automatically, and doing so will move focus back to the top of the page. This may create a frustrating or confusing experience.",
    link: "https://dequeuniversity.com/rules/axe/4.10/meta-refresh",
  },
  canonical: {
    title: "Document has a valid `rel=canonical`",
    description: "Canonical links suggest which URL to show in search results.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/canonical/",
  },
  "identical-links-same-purpose": {
    title: "Identical links have the same purpose.",
    description:
      "Links with the same destination should have the same description, to help users understand the link's purpose and decide whether to follow it.",
    link: "https://dequeuniversity.com/rules/axe/4.10/identical-links-same-purpose",
  },
  "heading-order": {
    title: "Heading elements appear in a sequentially-descending order",
    description:
      "Properly ordered headings that do not skip levels convey the semantic structure of the page, making it easier to navigate and understand when using assistive technologies.",
    link: "https://dequeuniversity.com/rules/axe/4.10/heading-order",
  },
  "html-has-lang": {
    title: "`<html>` element has a `[lang]` attribute",
    description:
      "If a page doesn't specify a `lang` attribute, a screen reader assumes that the page is in the default language that the user chose when setting up the screen reader. If the page isn't actually in the default language, then the screen reader might not announce the page's text correctly.",
    link: "https://dequeuniversity.com/rules/axe/4.10/html-has-lang",
  },
  "legacy-javascript-insight": {
    title: "Legacy JavaScript",
    description:
      "Polyfills and transforms enable older browsers to use new JavaScript features. However, many aren't necessary for modern browsers. Consider modifying your JavaScript build process to not transpile [Baseline](https://web.dev/articles/baseline-and-polyfills) features, unless you know you must support older browsers.",
    link: "https://web.dev/articles/baseline-and-polyfills",
  },
  "main-thread-tasks": {
    title: "Tasks",
    description:
      "Lists the toplevel main thread tasks that executed during page load.",
    link: undefined,
  },
  "has-hsts": {
    title: "Use a strong HSTS policy",
    description:
      "Deployment of the HSTS header significantly reduces the risk of downgrading HTTP connections and eavesdropping attacks. A rollout in stages, starting with a low max-age is recommended.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/has-hsts",
  },
  "meta-viewport": {
    title:
      '`[user-scalable="no"]` is not used in the `<meta name="viewport">` element and the `[maximum-scale]` attribute is not less than 5.',
    description:
      "Disabling zooming is problematic for users with low vision who rely on screen magnification to properly see the contents of a web page.",
    link: "https://dequeuniversity.com/rules/axe/4.10/meta-viewport",
  },
  "link-in-text-block": {
    title: "Links are distinguishable without relying on color.",
    description:
      "Low-contrast text is difficult or impossible for many users to read. Link text that is discernible improves the experience for users with low vision.",
    link: "https://dequeuniversity.com/rules/axe/4.10/link-in-text-block",
  },
  "aria-required-parent": {
    title: "`[role]`s are contained by their required parent element",
    description:
      "Some ARIA child roles must be contained by specific parent roles to properly perform their intended accessibility functions.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-required-parent",
  },
  "frame-title": {
    title: "`<frame>` or `<iframe>` elements have a title",
    description:
      "Screen reader users rely on frame titles to describe the contents of frames.",
    link: "https://dequeuniversity.com/rules/axe/4.10/frame-title",
  },
  "screenshot-thumbnails": {
    title: "Screenshot Thumbnails",
    description: "This is what the load of your site looked like.",
    link: undefined,
  },
  "js-libraries": {
    title: "Detected JavaScript libraries",
    description: "All front-end JavaScript libraries detected on the page.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/js-libraries/",
  },
  tabindex: {
    title: "No element has a `[tabindex]` value greater than 0",
    description:
      "A value greater than 0 implies an explicit navigation ordering. Although technically valid, this often creates frustrating experiences for users who rely on assistive technologies.",
    link: "https://dequeuniversity.com/rules/axe/4.10/tabindex",
  },
  "lcp-discovery-insight": {
    title: "LCP request discovery",
    description:
      "Optimize LCP by making the LCP image [discoverable](https://web.dev/articles/optimize-lcp#1_eliminate_resource_load_delay) from the HTML immediately, and",
    link: "https://web.dev/articles/optimize-lcp#1_eliminate_resource_load_delay",
  },
  "meta-description": {
    title: "Document has a meta description",
    description:
      "Meta descriptions may be included in search results to concisely summarize page content.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/meta-description/",
  },
  "forced-reflow-insight": {
    title: "Forced reflow",
    description:
      "A forced reflow occurs when JavaScript queries geometric properties (such as offsetWidth) after styles have been invalidated by a change to the DOM state. This can result in poor performance. Learn more about [forced reflows](https://developers.google.com/web/fundamentals/performance/rendering/avoid-large-complex-layouts-and-layout-thrashing#avoid-forced-synchronous-layouts) and possible mitigations.",
    link: "https://developers.google.com/web/fundamentals/performance/rendering/avoid-large-complex-layouts-and-layout-thrashing#avoid-forced-synchronous-layouts",
  },
  "aria-deprecated-role": {
    title: "Deprecated ARIA roles were not used",
    description:
      "Deprecated ARIA roles may not be processed correctly by assistive technology.",
    link: "https://dequeuniversity.com/rules/axe/4.10/aria-deprecated-role",
  },
  "unminified-javascript": {
    title: "Minify JavaScript",
    description:
      "Minifying JavaScript files can reduce payload sizes and script parse time.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/unminified-javascript/",
  },
  "render-blocking-insight": {
    title: "Render blocking requests",
    description:
      "Requests are blocking the page's initial render, which may delay LCP. [Deferring or inlining](https://web.dev/learn/performance/understanding-the-critical-path#render-blocking_resources) can move these network requests out of the critical path.",
    link: "https://web.dev/learn/performance/understanding-the-critical-path#render-blocking_resources",
  },
  accesskeys: {
    title: "`[accesskey]` values are unique",
    description:
      "Access keys let users quickly focus a part of the page. For proper navigation, each access key must be unique.",
    link: "https://dequeuniversity.com/rules/axe/4.10/accesskeys",
  },
  "unused-javascript": {
    title: "Reduce unused JavaScript",
    description:
      "Reduce unused JavaScript and defer loading scripts until they are required to decrease bytes consumed by network activity.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/unused-javascript/",
  },
  "server-response-time": {
    title: "Reduce initial server response time",
    description:
      "Keep the server response time for the main document short because all other requests depend on it.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/time-to-first-byte/",
  },
  label: {
    title: "Form elements have associated labels",
    description:
      "Labels ensure that form controls are announced properly by assistive technologies, like screen readers.",
    link: "https://dequeuniversity.com/rules/axe/4.10/label",
  },
  "structured-data": {
    title: "Structured data is valid",
    description:
      "Run the [Structured Data Testing Tool](https://search.google.com/structured-data/testing-tool/) and the [Structured Data Linter](http://linter.structured-data.org/) to validate structured data.",
    link: "https://search.google.com/structured-data/testing-tool/",
  },
  "button-name": {
    title: "Buttons have an accessible name",
    description:
      'When a button doesn\'t have an accessible name, screen readers announce it as "button", making it unusable for users who rely on screen readers.',
    link: "https://dequeuniversity.com/rules/axe/4.10/button-name",
  },
  "script-treemap-data": {
    title: "Script Treemap Data",
    description: "Used for treemap app",
    link: undefined,
  },
  "font-display-insight": {
    title: "Font display",
    description:
      "Consider setting [font-display](https://developer.chrome.com/blog/font-display) to swap or optional to ensure text is consistently visible. swap can be further optimized to mitigate layout shifts with",
    link: "https://developer.chrome.com/blog/font-display",
  },
  "total-byte-weight": {
    title: "Avoids enormous network payloads",
    description:
      "Large network payloads cost users real money and are highly correlated with long load times.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/total-byte-weight/",
  },
  "skip-link": {
    title: "Skip links are focusable.",
    description:
      "Including a skip link can help users skip to the main content to save time.",
    link: "https://dequeuniversity.com/rules/axe/4.10/skip-link",
  },
  "dom-size-insight": {
    title: "Optimize DOM size",
    description:
      "A large DOM can increase the duration of style calculations and layout reflows, impacting page responsiveness. A large DOM will also increase memory usage.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/dom-size/",
  },
  "target-size": {
    title: "Touch targets do not have sufficient size or spacing.",
    description:
      "Touch targets with sufficient size and spacing help users who may have difficulty targeting small controls to activate the targets.",
    link: "https://dequeuniversity.com/rules/axe/4.10/target-size",
  },
  "first-contentful-paint": {
    title: "First Contentful Paint",
    description:
      "First Contentful Paint marks the time at which the first text or image is painted.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/first-contentful-paint/",
  },
  "focus-traps": {
    title: "User focus is not accidentally trapped in a region",
    description:
      "A user can tab into and out of any control or region without accidentally trapping their focus.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/focus-traps/",
  },
  "logical-tab-order": {
    title: "The page has a logical tab order",
    description:
      "Tabbing through the page follows the visual layout. Users cannot focus elements that are offscreen.",
    link: "https://developer.chrome.com/docs/lighthouse/accessibility/logical-tab-order/",
  },
  bypass: {
    title: "The page contains a heading, skip link, or landmark region",
    description:
      "Adding ways to bypass repetitive content lets keyboard users navigate the page more efficiently.",
    link: "https://dequeuniversity.com/rules/axe/4.10/bypass",
  },
  "td-headers-attr": {
    title:
      "Cells in a `<table>` element that use the `[headers]` attribute refer to table cells within the same table.",
    description:
      "Screen readers have features to make navigating tables easier. Ensuring `<td>` cells using the `[headers]` attribute only refer to other cells in the same table may improve the experience for screen reader users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/td-headers-attr",
  },
  "redirects-http": {
    title: "Redirects HTTP traffic to HTTPS",
    description:
      "Make sure that you redirect all HTTP traffic to HTTPS in order to enable secure web features for all your users.",
    link: "https://developer.chrome.com/docs/lighthouse/pwa/redirects-http/",
  },
  deprecations: {
    title: "Avoids deprecated APIs",
    description: "Deprecated APIs will eventually be removed from the browser.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/deprecations/",
  },
  "viewport-insight": {
    title: "Optimize viewport for mobile",
    description:
      "Tap interactions may be [delayed by up to 300 ms](https://developer.chrome.com/blog/300ms-tap-delay-gone-away/) if the viewport is not optimized for mobile.",
    link: "https://developer.chrome.com/blog/300ms-tap-delay-gone-away/",
  },
  "errors-in-console": {
    title: "No browser errors logged to the console",
    description:
      "Errors logged to the console indicate unresolved problems. They can come from network request failures and other browser concerns.",
    link: "https://developer.chrome.com/docs/lighthouse/best-practices/errors-in-console/",
  },
  hreflang: {
    title: "Document has a valid `hreflang`",
    description:
      "hreflang links tell search engines what version of a page they should list in search results for a given language or region.",
    link: "https://developer.chrome.com/docs/lighthouse/seo/hreflang/",
  },
  "input-image-alt": {
    title: '`<input type="image">` elements have `[alt]` text',
    description:
      "When an image is being used as an `<input>` button, providing alternative text can help screen reader users understand the purpose of the button.",
    link: "https://dequeuniversity.com/rules/axe/4.10/input-image-alt",
  },
  "user-timings": {
    title: "User Timing marks and measures",
    description:
      "Consider instrumenting your app with the User Timing API to measure your app's real-world performance during key user experiences.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/user-timings/",
  },
  "efficient-animated-content": {
    title: "Use video formats for animated content",
    description:
      "Large GIFs are inefficient for delivering animated content. Consider using MPEG4/WebM videos for animations and PNG/WebP for static images instead of GIF to save network bytes.",
    link: "https://developer.chrome.com/docs/lighthouse/performance/efficient-animated-content/",
  },
  "inspector-issues": {
    title: "No issues in the `Issues` panel in Chrome Devtools",
    description:
      "Issues logged to the `Issues` panel in Chrome Devtools indicate unresolved problems. They can come from network request failures, insufficient security controls, and other browser concerns. Open up the Issues panel in Chrome DevTools for more details on each issue.",
    link: undefined,
  },
  "duplicate-id-aria": {
    title: "ARIA IDs are unique",
    description:
      "The value of an ARIA ID must be unique to prevent other instances from being overlooked by assistive technologies.",
    link: "https://dequeuniversity.com/rules/axe/4.10/duplicate-id-aria",
  },
  "th-has-data-cells": {
    title:
      '`<th>` elements and elements with `[role="columnheader"/"rowheader"]` have data cells they describe.',
    description:
      "Screen readers have features to make navigating tables easier. Ensuring table headers always refer to some set of cells may improve the experience for screen reader users.",
    link: "https://dequeuniversity.com/rules/axe/4.10/th-has-data-cells",
  },
};

export function getAuditDescription(auditId: string) {
  return (
    (
      PSI_AUDIT_DESCRIPTIONS as Record<
        string,
        { title: string; description: string; link: string | undefined }
      >
    )[auditId] || {
      title: auditId,
      description: "No description available",
      link: undefined,
    }
  );
}
